// extracted by mini-css-extract-plugin
export default {"container":"ExpenseForm_container__rQDPX","details":"ExpenseForm_details__MQ++9","inputs":"ExpenseForm_inputs__A5x5I"};